import React, { useState, useEffect } from 'react';
import LoadingSpinner from '../toolkit/LoadingSpinner';
// import Loader from './Loader';



const Delayed = ({ children, waitBeforeShow = 4000, message= "Loading....." }) => {
  const [isShown, setIsShown] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsShown(true);
    }, waitBeforeShow);
    return () => clearTimeout(timer);
  }, [waitBeforeShow]);

  return isShown ? children : (<LoadingSpinner message={message}/>);
};

export default Delayed;